import React from "react";
import * as styles from "./badge.module.css";

const Badge = (props) => {
    // eslint-disable-next-line camelcase
    const {text, is_new, classes = ""} = props;

    const classNames = [styles.badge, classes];
    // eslint-disable-next-line camelcase
    if (is_new) classNames.push(styles.badge_new);

    return <span className={classNames.join(" ")}>{text}</span>;
};

export default Badge;
